// src/components/AuthLayout.tsx
import React from "react";
import logoIcon from "../assets/images/site-logo-icon.png";
import { ArrowBack } from "../components/CustomIcons";
import { useNavigate } from "react-router-dom";

interface AuthLayoutProps {
  title?: string;
  children: React.ReactNode;
  showBackButton?: boolean;
  showFooter?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  title,
  children,
  showBackButton = true,
  showFooter = true,
}) => {
  const navigate = useNavigate();

  return (
    <div className="userPageWrapper">
      <div className="logoWrap">
        <img src={logoIcon} alt="Site Logo" />
      </div>
      {title && <h1>{title}</h1>}

      <div className="formWrapper">
        {showBackButton && (
          <div
            className="backBtn"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          ></div>
        )}

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
